import React from "react";
import { Youtube, Linkedin, Calendar, ArrowUpRight } from "lucide-react";
import { TEST_IDS } from "@/lib/testIds";
import { LINKS } from "@/lib/links";

const options = [
  {
    icon: Youtube,
    eyebrow: "01 · Watch",
    title: "Watch on YouTube",
    desc: "Explore educational videos, financial concepts, and short lessons on systems thinking.",
    cta: "Visit YouTube",
    href: LINKS.youtube,
    testId: TEST_IDS.learning.cardYoutube,
  },
  {
    icon: Linkedin,
    eyebrow: "02 · Read",
    title: "Connect on LinkedIn",
    desc: "Follow articles, observations, and professional updates from Liz’s ongoing work.",
    cta: "Connect on LinkedIn",
    href: LINKS.linkedin,
    testId: TEST_IDS.learning.cardLinkedin,
  },
  {
    icon: Calendar,
    eyebrow: "03 · Talk",
    title: "Book a Conversation",
    desc: "Schedule a quiet conversation about your goals, your questions, and where you are today.",
    cta: "Work with Liz",
    href: LINKS.calendly,
    testId: TEST_IDS.learning.cardCall,
  },
];

export const StartLearning = () => {
  return (
    <section
      id="learning"
      data-testid={TEST_IDS.learning.section}
      className="bg-paper py-28 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <p className="eyebrow mb-7">Start Learning</p>
          <h2
            className="font-serif text-nearblack leading-[1.06] text-balance"
            style={{ fontSize: "clamp(2rem, 4vw, 3.4rem)", fontWeight: 400 }}
          >
            Choose the path that’s most helpful{" "}
            <em className="italic text-camel">
              for where you are today
            </em>
            .
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-px bg-paperdeep">
          {options.map(({ icon: Icon, eyebrow, title, desc, cta, href, testId }) => (
            <a
              key={title}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={testId}
              className="group block bg-paper p-10 md:p-12 transition-all duration-500 hover:bg-paperdeep/60"
            >
              <div className="flex items-center justify-between mb-12">
                <span
                  className="font-serif text-camel"
                  style={{ fontSize: "0.7rem", letterSpacing: "0.32em", textTransform: "uppercase", fontWeight: 500 }}
                >
                  {eyebrow}
                </span>
                <Icon className="w-5 h-5 text-camel" strokeWidth={1.25} />
              </div>
              <h3
                className="font-serif text-nearblack leading-tight"
                style={{ fontSize: "clamp(1.7rem, 2.4vw, 2.4rem)", fontWeight: 400 }}
              >
                {title}
              </h3>
              <p className="mt-5 text-nearblack/70 leading-[1.8] text-[15px] font-light">
                {desc}
              </p>
              <div className="mt-10 inline-flex items-center gap-2 text-[11px] tracking-[0.32em] uppercase text-nearblack">
                {cta}
                <ArrowUpRight className="w-3.5 h-3.5 text-camel transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
